const root = `https://beta.pizzaluce.com/api/`

export function get(model, id){
    let url
    if (id && model !== 'location' && id && model !== 'menu') url = `https://beta.pizzaluce.com/api/${model}/${id}`
    else if (!id) url = `https://beta.pizzaluce.com/api/${model}`
    else if (id && model == 'location') url = `https://beta.pizzaluce.com/api/${model}/${id}/full`
    else if (id && model == 'menu') url = `https://beta.pizzaluce.com/api/${model}/${id}/full`
    
    return fetch(url)
    .then(res => res.json())
    .catch(err => err)
}

export function patch(model, body, id){
    return fetch(root + model + "/" + id, {
        method: 'PATCH',
        body: JSON.stringify(body),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            Token: "XzZSQhVLGAe2G4u8UPpeD4gSbFdu5Pxh"
        }
    })
    .then(res => {
        console.log(res)
        return res.json()
    })
    .catch(err => {
        console.log(err)
        return err
    })
}
export function post(model, body, token){

    return fetch(root + model, {
        method: 'POST', 
        body: JSON.stringify(body),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(res => {
        console.log(res)
        return res.json()
    })
    .catch(err => {
        console.log(err)
        return err
    })
}

export function remove(model, id){
    return fetch(root + model + `/${id}`, {
        method: 'DELETE',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(res => {
        console.log(res)
        return res.json()
    })
    .catch(err => err)
}

export async function FetchData(model, id){
    let url, options
    
    !id ? url = `https://beta.pizzaluce.com/api/${model}`
        : url = `https://beta.pizzaluce.com/api/${model}/${id}`
            
    try {   
        const res = await fetch(url, options)
        const json = await res.json()
        return json
    } catch (error) {
        return error
    } 
}